// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleDotMenuButton_deviceButton__9BLZG","icon":"ToggleDotMenuButton_icon__9t-1C"};